import phoneCrop from "../assets/img/IosDevelopment/phone.png";
import phoneFull from "../assets/img/IosDevelopment/phone-full.png";
import imagePhoneProcess from "../assets/img/IosDevelopment/2.png";

export const data = {
  hero: {
    title: "iOS Development",
    text: [
      "Apple devices are among the most popular today. The process of developing a native app for Apple is writing a program in one of the main iOS development languages: Objective-C or Swift. This path was created by the Apple corporation and assumes following all its ideas. Apple provides developers with the latest SDK (software development kit), documentation, and the Xcode development environment.",
    ],
    images: {
      full: phoneFull,
      regular: phoneCrop,
    },
  },
  description: {
    title: "Description",
    text: [
      "Apple devices are among the most popular today. The process of developing a native app for Apple is writing a program in one of the main iOS development languages: Objective-C or Swift.",
      "This path was created by the Apple corporation and assumes following all its ideas. Apple provides developers with the latest SDK (software development kit), documentation, and the Xcode development environment.",
    ],
  },
  iosLanguages: {
    title: "What language are iOS applications written in",
    content: [
      {
        paragraph: ["Apple developers have provided two options:"],
      },
      {
        list: [
          "Objective-C. A veteran with a long history, gradually fading into the background;",
          "Swift. Very young and rapidly gaining popularity among developers.",
        ],
      },
      {
        paragraph: [
          "Both languages ​​for creating and <a href='https://agilistrysoft.com/services/ios-native-automation'>testing iOS applications</a> relate to object-oriented programming (OOP) and successfully fulfill its main paradigms: inheritance, polymorphism, encapsulation, and abstraction. In simple terms, OOP is a coding style that allows a developer to group similar tasks into classes. The code follows the DRY (don’t repeat yourself) principleand becomes easy to maintain.",
        ],
      },
    ],
  },
  iosProcess: {
    title: "Our development on iOS process ",
    image: imagePhoneProcess,
    content: [
      {
        paragraph: [
          "If you need us to build a new iOS app from scratch, we could offer a complete team: ",
        ],
      },
      {
        list: [
          "Solution architect",
          "Swift. Very young and rapidly gaining popularity among developers.",
          "UX / UI Designer ",
          "Product Manger ",
        ],
      },
      {
        paragraph: [
          "Our iOS Engineers work with all types of modern architectures to support the testability and scalability of <a href='https://agilistrysoft.com/cases'>iOS projects</a>: ",
        ],
      },
      { list: ["MVVM", "VIPER", "CLEAN", "DISCOVER"] },
    ],
  },
  whyChoose: {
    title: `Why choose Agilistry for IOS development?`,
    description: [
      `The most relevant language for mobile development for iOS in ${new Date().getFullYear()} is Swift. The reason is not only in its speed and concise syntax but also in the fact that it is becoming the de facto development standard and is receiving more and more support from Apple developers. Our specialists, in turn, have a wide range of tools for developing a unique and relevant application just for your request!`,
    ],
  },
};
